import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthserviceService } from './authservice.service';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './masterlayout/home/home.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'home', component: HomeComponent, canActivate: [AuthserviceService] },

  {
    path: 'MAWS',
    loadChildren: () =>
      import('../app/scheme/scheme.module').then((m) => m.SchemeModule),
    canActivate: [AuthserviceService],
  },
  {
    path: 'DTP',
    loadChildren: () =>
      import('../app/scheme/scheme.module').then((m) => m.SchemeModule),
    canActivate: [AuthserviceService],
  },
  {
    path: 'CMA',
    loadChildren: () =>
      import('../app/scheme/scheme.module').then((m) => m.SchemeModule),
    canActivate: [AuthserviceService],
  },
  {
    path: 'MAS',
    loadChildren: () =>
      import('../app/scheme/scheme.module').then((m) => m.SchemeModule),
    canActivate: [AuthserviceService],
  },
  {
    path: 'revenue-landing',
    loadChildren: () =>
      import('../app/revenue/revenue.module').then((m) => m.RevenueModule),
    canActivate: [AuthserviceService],
  },
  { path: '**', component: HomeComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
